enum ReportType {
  BarChart = 'BarChart',
  HorizontalBarChart = 'HorizontalBarChart',
  PieChart = 'PieChart',
  DoughnutChart = 'DoughnutChart',
  StackedBarChart = 'StackedBarChart',
  HorizontalStackedBarChart = 'HorizontalStackedBarChart',
  GridResponseTable = 'GridResponseTable',
  ResponseTable = 'ResponseTable',
  StatisticsTable = 'StatisticsTable',
  RanksTableReport = 'RanksTableReport',
}
export default ReportType;

export function getReportTypeText(rType: ReportType) {
  switch (rType) {
    case ReportType.BarChart:
      return 'Bar Chart';
    case ReportType.HorizontalBarChart:
      return 'Horizontal Bar Chart';
    case ReportType.PieChart:
      return 'Pie Chart';
    case ReportType.DoughnutChart:
      return 'Doughnut Chart';
    case ReportType.StackedBarChart:
      return 'Stacked Bar Chart';
    case ReportType.HorizontalStackedBarChart:
      return 'Horizontal Stacked Bar Chart';
    case ReportType.GridResponseTable:
      return 'Grid';
    case ReportType.ResponseTable:
      return 'Response List';
    case ReportType.StatisticsTable:
      return 'Sum';
    case ReportType.RanksTableReport:
      return 'Rank';
    default:
      throw Error(`Unknown Report Type (${rType})`);
  }
}
